import { ImageAttributes } from '@/types/LeadGeneration';

export const useImageData = (imageDetails?: ImageAttributes, defaultHeight = 500, defaultWidth = 500) => {
  const image = {
    url: imageDetails?.url ?? '',
    width: imageDetails?.width ?? defaultWidth,
    height: imageDetails?.height ?? defaultHeight,
    alt: imageDetails?.alternativeText ?? '',
  };

  return { image };
};
